<label>{{ filter.label }}</label>
<div class="d-inline-flex">
  <select [(ngModel)]="filter.operator" class="form-control" (change)="filterChange.emit(filter)">
    <option value="equals">le</option>
    <option value="greaterThanOrEqual">à partir du</option>
    <option value="lessThanOrEqual">avant le</option>
    <option value="between">du ... au ...</option>
  </select>

  <div class="ml-2">
    <input type="date" class="form-control" [(ngModel)]="filter.tempValue" (change)="filterChange.emit(filter)" />
  </div>
  <div class="ml-2" *ngIf="filter.operator === 'between'">
    <input type="date" class="form-control" [(ngModel)]="filter.tempSecondValue" (change)="filterChange.emit(filter)" />
  </div>
</div>
